import script from "./HowWeWorkSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HowWeWorkSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__